import { loggedIn } from 'Helpers/session';

const REFRESH_LOGGED_IN = 'session/REFRESH_LOGGED_IN';
const SET_SHOW_KYC_BANNER = 'session/SET_SHOW_KYC_BANNER';
const SET_SHOW_SESSION_REMINDER = 'session/SET_SHOW_SESSION_REMINDER';
const LOAD_CUSTOMER_CONSENT_MESSAGES = 'session/LOAD_CUSTOMER_CONSENT_MESSAGES';
const LOAD_RESTRICTIONS = 'session/LOAD_RESTRICTIONS';
const LOAD_KYC_STRATEGIES_V2 = 'session/LOAD_KYC_STRATEGIES_V2';
const LOAD_SESSION_INFO = 'session/LOAD_SESSION_INFO';
const LOAD_RDL_INFO = 'session/LOAD_RDL_INFO';
const CLOSE_RDL_CONFIRMATION = 'session/CLOSE_RDL_CONFIRMATION';

export const refreshLoggedIn = () => ({
  type: REFRESH_LOGGED_IN,
});

export const setShowKycBanner = (showKycBanner) => ({
  type: SET_SHOW_KYC_BANNER,
  showKycBanner,
});

export const setShowSessionReminder = (showSessionReminder) => ({
  type: SET_SHOW_SESSION_REMINDER,
  showSessionReminder,
});

export const loadCustomerConsentMessages = (messages) => ({
  type: LOAD_CUSTOMER_CONSENT_MESSAGES,
  messages,
});

export const loadRestrictions = (restrictions) => ({
  type: LOAD_RESTRICTIONS,
  restrictions,
});

export const loadKycStrategiesV2 = (strategies) => ({
  type: LOAD_KYC_STRATEGIES_V2,
  strategies,
});

export const loadSessionInfo = (session) => ({
  type: LOAD_SESSION_INFO,
  payload: {
    sessionStart: session.active ? session.startTimeMillis : null,
    showSessionReminder: session.sessionReminder || false,
  },
});

export const loadRdlInfo = (rdl) => ({
  type: LOAD_RDL_INFO,
  payload: {
    showRdlConfirmation: rdl.pending,
    pendingRdl: rdl.pending ? {
      amount: rdl.amount,
      period: rdl.period?.description || 'no_limit',
    } : null,
  },
});

export const closeRdlConfirmation = () => ({
  type: CLOSE_RDL_CONFIRMATION,
});

const initialState = {
  loggedIn: loggedIn(),
  showKycBanner: false,
  showSessionReminder: false,
  showRdlConfirmation: false,
  customerConsentMessages: [],
  restrictions: [],
  kycStrategiesV2: [],
  kycStrategiesV2WereLoaded: false,
  sessionStart: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case REFRESH_LOGGED_IN:
      return {
        ...state,
        loggedIn: loggedIn(),
      };
    case SET_SHOW_KYC_BANNER:
      return {
        ...state,
        showKycBanner: action.showKycBanner,
      };
    case SET_SHOW_SESSION_REMINDER:
      return {
        ...state,
        showSessionReminder: action.showSessionReminder,
      };
    case LOAD_CUSTOMER_CONSENT_MESSAGES:
      return {
        ...state,
        customerConsentMessages: action.messages,
      };
    case LOAD_RESTRICTIONS:
      return {
        ...state,
        restrictions: action.restrictions,
      };
    case LOAD_KYC_STRATEGIES_V2:
      return {
        ...state,
        kycStrategiesV2: action.strategies,
        kycStrategiesV2WereLoaded: true,
      };
    case LOAD_SESSION_INFO:
    case LOAD_RDL_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case CLOSE_RDL_CONFIRMATION:
      return {
        ...state,
        showRdlConfirmation: false,
        pendingRdl: null,
      };
    default:
      return state;
  }
};
